import type { InjectionKey, Ref } from 'vue'

// ── Injection key ────────────────────────────────────────
export const GAME_RESET_KEY: InjectionKey<Ref<(() => void) | null>> = Symbol('game:reset')

// ── Called by the games layout to set up the provide ────
export function provideGameReset() {
  const handler = ref<(() => void) | null>(null)
  provide(GAME_RESET_KEY, handler)
  return handler
}

// ── Called by game pages to register a reset handler ────
// ── Called by GameFab to execute / inspect the handler ──
export function useGameReset() {
  const handler = inject(GAME_RESET_KEY)

  function register(fn: () => void) {
    if (!handler) {
      return
    }
    handler.value = fn
    onUnmounted(() => {
      if (handler) {
        handler.value = null
      }
    })
  }

  function execute() {
    handler?.value?.()
  }

  const hasHandler = computed(() => !!handler?.value)

  return { execute, hasHandler, register }
}
